export const NotificationsArrow = {
  position: 'bottom',
  color: 'white',
  size: 10
};

export const NotificationsPopover = {
  align: 'center',
  position: ['bottom']
};
